import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
    },
    contentPrices: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 10
    },
    infoPrice: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    PickerSelect: {
        borderRadius: 4,
        paddingHorizontal: 10,
        height: 40,
        marginTop: 10,
        color: '#222'
    },
    contentInput: {
        marginBottom: 20
    },
    transferValueInfo: {
        position: 'absolute',
        bottom: 110,
        alignSelf: 'center',
        fontSize: 14,
        fontWeight: '400'
    }
});

export default styles;
